<template>
	<div class="ind-arc">
		<img :src="data" />
	</div>
</template>

<script>
	export default {
		name: 'IndustryArc',
		props: ['data']
	}
</script>

<style>
	@media (min-width:992px) {
		.ind-arc {
			background-color: #eaf2f9;
			display: flex;
			justify-content: center;
		}
	}

	@media (max-width:992px) {
		.ind-arc {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.ind-arc img {
			width: 100%;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/IndustryArc.vue